import Wasm from "./wasm";

interface IItem {
	source: string;
	id: number;
}

export default class WasmHiddenPois {
	_name: string;

	_list: Module.HiddenPoiList;

	_poisList: Array<IItem>;

	constructor(name: string) {
		this._name = name;
		this._poisList = [];
		this._list = null;
	}

	set wasm(wasm: Wasm) {
		wasm.mapControl.getHiddenPoiList(this._name).then(list => {
			this._list = list;
			this.updateWasm();
		});
	}

	// destroy nemame - neni co mazat

	clear() {
		this._poisList.length = 0;
	}

	addPoi(source: IItem["source"], id: IItem["id"]) {
		this._poisList.push({ source, id });
	}

	addPois(items: Array<IItem>) {
		for (const item of items) {
			this._poisList.push(item);
		}
	}

	async updateWasm() {
		if (this._list) {
			await this._list.clear();

			for (const item of this._poisList) {
				this._list.add(item.id, item.source);
			}

			await this._list.invoke();
		}
	}
}
